var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarWarningOutline = function SvgCalendarWarningOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9458 12.6568L12.1314 22.2453C11.7285 23.0476 12.3007 24 13.1855 24H22.8145C23.6993 24 24.2715 23.0476 23.8686 22.2453L19.0542 12.6568C18.6144 11.7811 17.3856 11.7811 16.9458 12.6568ZM16.7359 21.6461C16.7359 20.9802 17.266 20.4403 17.9199 20.4403C18.5738 20.4403 19.1039 20.9802 19.1039 21.6461C19.1039 22.312 18.5738 22.8518 17.9199 22.8518C17.266 22.8518 16.7359 22.312 16.7359 21.6461ZM18.8079 15.6173C18.8079 15.1178 18.4103 14.713 17.9199 14.713C17.4295 14.713 17.0319 15.1178 17.0319 15.6173V18.6317C17.0319 19.1311 17.4295 19.536 17.9199 19.536C18.4103 19.536 18.8079 19.1311 18.8079 18.6317V15.6173Z",
    fill: "#3A3A47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C8.333 18.001 8 17.668 8 17C8 16.332 8.335 15.999 9.002 16H10C10.667 16 11 16.333 11 17C11 17.667 10.667 18 10 18H9Z",
    fill: "#3A3A47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14C8.333 14.001 8 13.668 8 13C8 12.332 8.335 11.999 9.002 12H10C10.667 12 11 12.333 11 13C11 13.667 10.667 14 10 14H9Z",
    fill: "#3A3A47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13C13 13.668 13.333 14.001 14 14H14.0321L15.0363 12H14.002C13.335 11.999 13 12.332 13 13Z",
    fill: "#3A3A47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4H6C4.667 4 4 4.668 4 6.004V20C4 21.333 4.667 22 6 22H10.0986C10.1548 21.7796 10.2356 21.5611 10.3427 21.3478L11.0194 20H6V10H17.9977H18C18.5655 10.0002 19.1307 10.1482 19.6281 10.4441C19.6713 10.4698 19.7146 10.497 19.7568 10.525C19.7837 10.5429 19.8104 10.5612 19.8368 10.5799C19.8923 10.6193 19.9467 10.6607 20 10.704V6C20 4.667 19.333 4 18 4H17V2.941C17 2.314 16.667 2 16 2C15.333 2 15 2.314 15 2.941V4H9.004V3C9.004 2.333 8.67 2 8 2C7.33 2 6.998 2.333 7 3V4ZM6 8V6H18V8H6Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarWarningOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-warning-outline.43c4055d.svg";
export { ForwardRef as ReactComponent };